import { render } from "./App.vue?vue&type=template&id=467113c9"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=467113c9&lang=scss"

import exportComponent from "C:\\__MRYNK\\_2022\\19dnl008lot-stop45\\frontend2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__